import {
  REPORTS,
  REPORT_INVENTORY,
  REPORT_PURCHASES,
  REPORT_STOCK_LEDGER,
  REPORT_PRODUCT_LEDGER,
  REPORT_PRODUCT_LEDGER_VIEW,
  REPORT_GRN,
  REPORT_GRN_VIEW,
  REPORT_REQ_TRACKING,
  REPORT_REQ_TRACKING_VIEW,
  REPORT_SPR_DETAIL,
  REPORT_SPR_DETAIL_VIEW,
} from '@constants/internal-route.constant'
import {ROUTE_CODES} from '@constants/route-codes.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'

export const ReportRoutes: IAppRoutes = {
  link: REPORTS,
  routeCode: ROUTE_CODES.REPORTS,
  childrens: [
    {link: REPORT_INVENTORY, routeCode: ROUTE_CODES.RPT_INVENTORY, element: lazy(() => import('@modules/report/inventory'))},
    {link: REPORT_PURCHASES, routeCode: ROUTE_CODES.RPT_PURCHASES, element: lazy(() => import('@modules/report/purchases'))},
    {link: REPORT_STOCK_LEDGER, routeCode: ROUTE_CODES.RPT_STOCK_LEDGER, element: lazy(() => import('@modules/report/stock-ledger'))},
    {link: REPORT_PRODUCT_LEDGER, routeCode: ROUTE_CODES.RPT_PRODUCT_LEDGER, element: lazy(() => import('@modules/report/product-ledger'))},
    {link: REPORT_GRN, routeCode: ROUTE_CODES.RPT_GRN, element: lazy(() => import('@modules/report/grn'))},
    {link: REPORT_REQ_TRACKING, routeCode: ROUTE_CODES.RPT_REQ_TRACKING, element: lazy(() => import('@modules/report/requisition-tracking'))},
    {link: REPORT_SPR_DETAIL, routeCode: ROUTE_CODES.RPT_SPR_DETAIL, element: lazy(() => import('@modules/report/spr-detail'))},
    // The drill-downs, each a routed PAGE rather than a drawer over its report. They carry the SAME
    // routeCode as the report they belong to -- PrivateRoutes reads a MISSING code as "always
    // allow", which is the wrong default for a document that is otherwise behind a report gate.
    {link: REPORT_PRODUCT_LEDGER_VIEW({id: ':id'}), routeCode: ROUTE_CODES.RPT_PRODUCT_LEDGER, element: lazy(() => import('@modules/report/product-ledger/View'))},
    {link: REPORT_GRN_VIEW({id: ':id'}), routeCode: ROUTE_CODES.RPT_GRN, element: lazy(() => import('@modules/report/grn/View'))},
    {link: REPORT_REQ_TRACKING_VIEW({id: ':id'}), routeCode: ROUTE_CODES.RPT_REQ_TRACKING, element: lazy(() => import('@modules/report/requisition-tracking/View'))},
    {link: REPORT_SPR_DETAIL_VIEW({id: ':id'}), routeCode: ROUTE_CODES.RPT_SPR_DETAIL, element: lazy(() => import('@modules/report/spr-detail/View'))},
  ],
}
